
import { getApiVersion } from './config.js'
import { makeGetRequest, makePostRequest } from './util.js'

const RELATIVE_PREFIX = 'pdf_upload'


function requestFormPdfUpload(data, headers) {
  return makePostRequest(`${getApiVersion()}/${RELATIVE_PREFIX}/upload/request_form`, data, (existingHeaders) => {
    for (const headerKey in headers) {
      existingHeaders[headerKey] = headers[headerKey]
    }
    return existingHeaders
  })
}

function requestFormPdfCheck(queryParams) {
  var filteredQueryParams = {}
  if (queryParams?.id) filteredQueryParams.id = queryParams.id
  return makeGetRequest(`${getApiVersion()}/${RELATIVE_PREFIX}/check/request_form`, filteredQueryParams)
}

function requestFormPdfParsedContent(data) {
  return makePostRequest(`${getApiVersion()}/${RELATIVE_PREFIX}/parsed_content/request_form`, data)
}

export {
  requestFormPdfUpload,
  requestFormPdfCheck,
  requestFormPdfParsedContent,
}
